export default __webpack_public_path__ + "9a6bc8dcc4534995ba24071ee64cacbf.png";